// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__2_AZ3","link":"Item_link__efzZ8","title":"Item_title__30srX","preview":"Item_preview__MGtTS","content":"Item_content__3GIuB","close":"Item_close__2eUlY"};